import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { InsertEmpresaRequest } from 'src/app/content/empresa/requests/insert-cuenta-emp-request';
import { EmpresaService } from 'src/app/content/empresa/services/empresa.service';
import { AuthUser } from 'src/app/login/administrador/AuthUser';
import { LoginCompanyService } from 'src/app/login/services/login-company.service';
import { UserRole } from 'src/app/_models/userEnum';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-empresa-registro',
  templateUrl: './empresa-registro.component.html',
  styleUrls: ['./empresa-registro.component.css']
})
export class EmpresaRegistroComponent implements OnInit {
  check = false;

  loading = false;
  submitted = false;
  returnUrl: string;
  isPageLoaded = false;

  registerCompanyForm: FormGroup;
  constructor(private fb: FormBuilder,
              private empresaService : EmpresaService,
              private router: Router,
              public authService : AuthService,
              private toastr: ToastrService
    ){}

  ngOnInit() {
    const currentUser = this.authService.getUser() as AuthUser;
    if(currentUser) {
      if(currentUser.role===UserRole.Graduated)
      {
        this.router.navigate(['/egresado']);
      }
      if(currentUser.role===UserRole.Company)
      {
        this.router.navigate(['/empresa']);
      }
    } else {
      this.isPageLoaded = true;
      this.initLoginForm();
      this.registerCompanyForm.setValidators(this.comparisonValidator());
    }
  }
  

  initLoginForm() {
    this.registerCompanyForm = new FormGroup(
      {
        username: new FormControl('', [Validators.required,
          Validators.pattern(/^[^\sñ]+$/),
          Validators.maxLength(15),
          Validators.minLength(5),
          Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]),
        password: new FormControl('', [
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(50),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{6,50}$/)]),
        last_name: new FormControl('', [Validators.required,Validators.minLength(3),Validators.maxLength(40)]),
        first_name: new FormControl('', [Validators.required,Validators.minLength(3),Validators.maxLength(45)]),
        companyName: new FormControl('', [Validators.required,Validators.minLength(4),Validators.maxLength(100)]),
        password_confirmation: new FormControl('', Validators.required),
        check : new FormControl(false)
      });
    }

    comparisonValidator() : ValidatorFn{
      return (formGroup: FormGroup): ValidationErrors => {
        const password = formGroup.get('password');
        const confirmPassword = formGroup.get('password_confirmation');
         if (password.value !== confirmPassword.value) {
          confirmPassword.setErrors({mismatch: true});
         } else {
          confirmPassword.setErrors(null);
         }
         return;
      };
    }
    
  tryRegister()
  {
    this.submitted = true;
    if (this.registerCompanyForm.invalid)
    {
      this.toastr.warning('Verifica los datos.', 'Advertencia', {
        tapToDismiss: false
      });
      return;
    }
    let data : InsertEmpresaRequest = new InsertEmpresaRequest();
    data.usuario=this.f.username.value;
    data.password=this.f.password.value;
    data.nombreResponsable=this.f.first_name.value+' '+this.f.last_name.value;
    data.nombreEmpresa=this.f.companyName.value;
    this.empresaService.crearCuentaEmpresa(data).subscribe(response=>
      {
        if(!response.success)
        {
          this.toastr.error(response.mensaje, 'Error', {
            toastClass: 'ngx-toastr toast-error'
          });
          return;
        }

        let returnUrl = '/login-empresa';
        if (this.returnUrl) {
          returnUrl = this.returnUrl;
        }
        this.toastr.success('Registro exitoso');
        this.router.navigate([returnUrl]);
      }),
      (error=>{
          this.submitted=false;
        });  

  }


  // convenience getter for easy access to form fields
  get f() {
    return this.registerCompanyForm.controls;
  }

}
